export const buildMobileDialogMessage = ({ type, title, description, redirectTo, okText }) => (
  {type, title, description, redirect_to: redirectTo, ok_text: okText}
);

export const buildButtonActon = (action, url, title) => (
  {action, url, title}
);

export const MOBILE_DIALOG_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
}